module.exports = __webpack_public_path__ + "img/tips-socks.e6e5b23a.svg";